import { createFileRoute, redirect } from "@tanstack/react-router";

// The Parent Library hub lives at /blog.
export const Route = createFileRoute("/learn/")({
  beforeLoad: () => {
    throw redirect({ to: "/blog", replace: true, statusCode: 301 });
  },
});
